import ChatbotAlgorithmsCase from './ChatbotAlgorithmsCase';

export default ChatbotAlgorithmsCase;